import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { QuickStatsService } from 'src/app/landing/quick-stats.service';
import { OrgService } from 'src/app/_services/org.service';
import { quickStatsCards, linkCards } from './data'; // Adjust the path as necessary
import { Role as Roles } from 'src/app/_helpers/roles';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.css'],
})
export class LandingComponent implements OnInit {
	quickStatsCards = quickStatsCards;
	linkCards = linkCards;
	decoded: any;
	user: any;
	node: any;
	headNode: any;
	dashboard = null;
	public roles = Roles;
	iframeUrl: SafeResourceUrl;

	constructor(
		private jwtHelper: JwtHelperService,
		private quickStatsService: QuickStatsService,
		private orgService: OrgService,
		private sanitizer: DomSanitizer,
		private modalService: NgbModal
	) {
		this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('/assets/LMS/story.html');
	}

	openModal(content: any) {
		this.modalService.open(content, {
			windowClass: 'fullscreen-modal',
			backdrop: 'static',
			keyboard: false,
		});
	}
	shouldInclude(role: string): boolean {
		if (this.decoded.role == Roles.Admin || this.decoded.role == Roles.AdminLite) {
			return false;
		} else {
			return true;
		}
		//	return this.decoded.role != Roles.Admin && this.decoded.role !== Roles.AdminLite;
	}

	ngOnInit(): void {
		this.orgService.init();
		const token = localStorage.getItem('currentUser');
		this.decoded = this.jwtHelper.decodeToken(token);
		this.user = this.decoded.user;
		this.dashboard = this.decoded.role;
		console.log('dashboard', this.dashboard);

		this.headNode = this.decoded.attachedNode;

		if (this.decoded.role !== Roles.Admin && this.decoded.role !== Roles.AdminLite) {
			this.quickStatsService.totalStudents$(this?.headNode.id).subscribe((data) => {
				console.log('test', this.quickStatsCards);
				this.quickStatsCards.student.statValue = data;
				this.quickStatsCards.student.isLoading = false;
			});

			this.quickStatsService.totalAssessments$(this?.headNode.id).subscribe((data) => {
				this.quickStatsCards.assessments.statValue = data;
				this.quickStatsCards.assessments.isLoading = false;
			});

			this.quickStatsService.phases$(this?.headNode.id).subscribe((data) => {
				this.quickStatsCards.phase1.statValue = data[1];
				this.quickStatsCards.phase1.isLoading = false;
				this.quickStatsCards.phase2.statValue = data[2];
				this.quickStatsCards.phase2.isLoading = false;
				this.quickStatsCards.phase3.statValue = data[3];
				this.quickStatsCards.phase3.isLoading = false;
				this.quickStatsCards.notAssessed.statValue = data['notAssessed'];
				this.quickStatsCards.notAssessed.isLoading = false;
				this.quickStatsCards.complete.statValue = data['completed']['current']['count'];
				this.quickStatsCards.complete.isLoading = false;
			});
		}
	}

	navigateTo(url: string): void {
		if (url.startsWith('https://')) {
			window.open(url, '_blank');
		} else {
			window.location.href = url;
		}
	}
}
